import { Document, Packer, Paragraph, TextRun, PageBreak } from "docx";
import { saveAs } from "file-saver";

export const downloadSongsAsDocx = async (songs, filename = "Songbook") => {
  const doc = new Document({
    sections: [
      {
        properties: {
          page: {
            margin: { top: 720, right: 720, bottom: 720, left: 720 }
          }
        },
        children: songs.flatMap((song, index) => {
          // Parse Draft.js format
          let lyrics = "";

          try {
            const parsed = JSON.parse(song.text);
            if (parsed.blocks) {
              lyrics = parsed.blocks
                .map((block) => block.text || "")
                .join("\n");
            }
          } catch (e) {
            lyrics = song.text || "";
          }

          return [
            // Page break before each song (except first)
            ...(index > 0
              ? [new Paragraph({ children: [new PageBreak()] })]
              : []),

            // Title
            new Paragraph({
              spacing: { after: 100 },
              children: [
                new TextRun({
                  text: song.title || "Untitled",
                  bold: true,
                  size: 48,
                  font: "Arial"
                })
              ]
            }),

            // Subtitle (if exists)
            ...(song.subtitle
              ? [
                  new Paragraph({
                    spacing: { after: 100 },
                    children: [
                      new TextRun({
                        text: song.subtitle,
                        size: 28,
                        font: "Arial",
                        color: "666666"
                      })
                    ]
                  })
                ]
              : []),

            // Key, Tempo, and Time on same line
            new Paragraph({
              spacing: { after: 300 },
              children: [
                new TextRun({
                  text: `Key: ${song.key || "N/A"}  |  Tempo: ${song.tempo || "N/A"}  |  Time: ${song.time || "N/A"}`,
                  size: 24,
                  font: "Arial",
                  color: "888888"
                })
              ]
            }),

            // Lyrics
            ...lyrics.split("\n").map(
              (line) =>
                new Paragraph({
                  children: [
                    new TextRun({
                      text: line || " ",
                      font: "Arial", // Monospace, but cleaner than Courier
                      size: 22
                    })
                  ]
                })
            )
          ];
        })
      }
    ]
  });

  const blob = await Packer.toBlob(doc);
  saveAs(blob, `${filename}.docx`);
};
